import React from 'react';
import PropTypes from 'prop-types';
import { FormCardSpaced } from 'modules/common';

import { UpsellVideoEmbed, EnhancedUpsell, UpsellName, UpsellAction, Widgets } from './sections';
import { WIDGETS_MAP } from 'modules/common/widgets/tools';
import { ImageOnUpsell } from './sections';
import UpsellContactCard from './sections/upsell-contact-card.component';
import AcceptContactButton from './sections/contact-card-accept-decline.component';

function ContactCardUpsell(props) {
  return (
    <>
      <FormCardSpaced>
        <UpsellName {...props} />
        <UpsellAction {...props} />
        <AcceptContactButton {...props} />
      </FormCardSpaced>

      <FormCardSpaced>
        <UpsellContactCard {...props} />
        <ImageOnUpsell
          {...props}
          imageFieldName="contact_card_image"
          title="Contact Card Image"
          subtitle="Select an image to display on your contact card. Recommended image size is 400x400px."
          imageType="CONTACT_CARD_IMAGE"
        />
      </FormCardSpaced>

      <UpsellVideoEmbed {...props} />
      <EnhancedUpsell {...props} />

      <Widgets
        {...props}
        widgetOptions={ContactCardUpsell.widgets}
        primaryColor={props.primaryColor}
        secondaryColor={props.secondaryColor}
      />
    </>
  );
}

ContactCardUpsell.title = 'Contact Card';
ContactCardUpsell.description = 'Allow donors to download a digital contact card for your organization.';
ContactCardUpsell.icon = 'upsell-contact-card';
ContactCardUpsell.type = 'CONTACTCARD';
ContactCardUpsell.widgets = [
  WIDGETS_MAP.SHOTCLOCK.value,
  WIDGETS_MAP.COUNTDOWN.value,
  WIDGETS_MAP.COUNTDOWNTOMIDNIGHT.value,
  WIDGETS_MAP.SOCIALLINKS.value,
  WIDGETS_MAP.POLLRESULTS.value,
  WIDGETS_MAP.CONFETTI.value,
];

ContactCardUpsell.propTypes = {
  editedUpsell: PropTypes.object.isRequired,
  onUpdateEditedUpsell: PropTypes.func.isRequired,
  primaryColor: PropTypes.string,
  secondaryColor: PropTypes.string,
};

export default ContactCardUpsell;
